import React from "react";
import { Modal, Button } from "@/Components/Common/Tailwind";
import { QRCodeSVG } from "qrcode.react";
import { API } from "../../api";
import { getAccessToken } from "../../api/auth";
import { getPurchaseGiftBadgeLabel } from "../../pages/UserPage/purchaseList/actionVisibility.mjs";

type TicketInfo = {
  id: string | number;
  name: string;
  state?: string;
  expiration_date?: string;
  orderDate?: string;
  amount?: number;
  gifted?: string | boolean;
};

type QrResponse = {
  qr: string;
};

interface TicketPurchaseDetailModalProps {
  setVisible: (value: boolean) => void;
  visible: boolean;
  info: TicketInfo;
  setInfo: (value: Partial<TicketInfo>) => void;
  onGift?: () => void;
  onRefund?: () => void;
}

const TicketPurchaseDetailModal: React.FC<TicketPurchaseDetailModalProps> = ({
  setVisible,
  visible,
  info,
  setInfo,
  onGift,
  onRefund,
}) => {
  const [checkQrCode, setCheckQrCode] = React.useState("");
  const giftBadgeLabel = getPurchaseGiftBadgeLabel(info);

  const togModal = () => {
    setVisible(!visible);
    setCheckQrCode("");
  };

  const getQrCode = async (): Promise<QrResponse> => {
    const accessToken = getAccessToken();

    const response = await API.get(`/ticket/ticket-qr/${info.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  };

  if (!Object.keys(info ?? {}).length) {
    return null;
  }

  return (
    <Modal toggle={togModal} isOpen={visible} centered>
      <div>
        <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
          {giftBadgeLabel ? (
            <span className="inline-flex rounded-full bg-rose-100 px-3 py-1 text-xs font-semibold text-rose-600">
              {giftBadgeLabel}
            </span>
          ) : <span />}
          <div className="flex justify-center">
            {checkQrCode ? (
              <QRCodeSVG value={checkQrCode} />
            ) : (
              <Button
                onClick={() => {
                  getQrCode().then((data) => {
                    setCheckQrCode(data.qr);
                  });
                }}
                variant="primary"
              >
                QR 생성하기
              </Button>
            )}
          </div>
        </div>
        <ul className="list-group">
          <li className="list-group-item">
            <span className="font-semibold inline-block w-24">티켓ID :</span>
            <span>{info.id}</span>
          </li>
          <li className="list-group-item">
            <span className="font-semibold inline-block w-24">티켓명 :</span>
            <span>{info.name}</span>
          </li>
          <li className="list-group-item">
            <span className="font-semibold inline-block w-24">상태 :</span>
            <span>{info.state}</span>
          </li>
          {info.expiration_date ? (
            <li className="list-group-item">
              <span className="font-semibold inline-block w-24">만료일 :</span>
              <span>{info.expiration_date}</span>
            </li>
          ) : null}
          {info.orderDate ? (
            <li className="list-group-item">
              <span className="font-semibold inline-block w-24">결제일 :</span>
              <span>{info.orderDate}</span>
            </li>
          ) : null}
          {typeof info.amount === "number" ? (
            <li className="list-group-item">
              <span className="font-semibold inline-block w-24">결제금액 :</span>
              <span>{info.amount.toLocaleString()}원</span>
            </li>
          ) : null}
        </ul>
        {onGift || onRefund ? (
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {onGift ? (
              <Button variant="secondary" onClick={onGift}>
                선물하기
              </Button>
            ) : null}
            {onRefund ? (
              <Button variant="danger" onClick={onRefund}>
                환불
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className="mt-4 flex justify-center gap-2">
        <Button
          variant="secondary"
          onClick={() => {
            setInfo({});
            setVisible(!visible);
            setCheckQrCode("");
          }}
        >
          닫기
        </Button>
      </div>
    </Modal>
  );
};

export default TicketPurchaseDetailModal;
